module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      "error": ((_vm.getMe.remainingDays < 1 && _vm.isHolidaysCalendar && !_vm.editing) || _vm.getApiError)
    },
    attrs: {
      "id": "BookHolidayPopup"
    }
  }, [_c('div', {
    staticClass: "book-holiday-popup"
  }, [_c('div', {
    staticClass: "container",
    class: {
      top: _vm.boxTop,
      left: _vm.boxLeft
    }
  }, [(_vm.isHolidaysCalendar && _vm.bookedDays) ? _c('h3', [_vm._v(" " + _vm._s(_vm.holidaysText.text_title))]) : (_vm.isHolidaysCalendar && _vm.holidayName) ? _c('h3', [_vm._v(_vm._s(_vm.publicBookedText.text_title))]) : (!_vm.isHolidaysCalendar && _vm.holidayName) ? _c('h3', [_vm._v(_vm._s(_vm.publicBookedText.text_title))]) : (!_vm.isHolidaysCalendar) ? _c('h3', [_vm._v(_vm._s(_vm.publicText.text_title))]) : _c('h3', [_vm._v(_vm._s(_vm.holidaysBookedText.text_title))]), (_vm.holidayName) ? _c('p', [_vm._v(_vm._s(_vm.holidayName))]) : _vm._e(), (_vm.isHolidaysCalendar && !_vm.showOnly && !_vm.holidayName) ? _c('div', {
    staticClass: "itemsline"
  }, [_c('div', {
    staticClass: "from-day"
  }, [_c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("From")]), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.startDate))])]), (!_vm.editing) ? _c('div', {
    staticClass: "count-days half"
  }, [_vm._v(_vm._s(_vm.bookedDays + _vm.holidaysText.text_days + (_vm.getMe.remainingDays - _vm.bookedDays) + _vm.holidaysText.text_remaining))]) : _c('div', {
    staticClass: "count-days half"
  }, [_vm._v(_vm._s(_vm.workingDays + _vm.holidaysText.text_days + (_vm.getMe.remainingDays) + _vm.holidaysText.text_remaining))])]), _c('div', {
    staticClass: "to-day"
  }, [_c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("To")]), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.end))])]), (!_vm.editing) ? _c('div', {
    staticClass: "add-days half"
  }, [_vm._v(_vm._s(_vm.holidaysText.hint_add_days))]) : _vm._e()])]) : _vm._e(), (_vm.getMe.remainingDays < 1 && _vm.isHolidaysCalendar && !_vm.editing && !_vm.holidayName) ? _c('div', {
    staticClass: "itemsline error"
  }, [_vm._v(_vm._s(_vm.limitDaysText))]) : _vm._e(), (_vm.getApiError) ? _c('div', {
    staticClass: "itemsline error"
  }, [_vm._v(_vm._s(_vm.getApiError))]) : _vm._e(), (!_vm.isHolidaysCalendar || _vm.showOnly || _vm.holidayName) ? _c('div', {
    staticClass: "itemsline public"
  }, [_c('div', {
    staticClass: "from-day"
  }, [_c('div', [_c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.startDate))])])])]) : _vm._e(), (!_vm.isHolidaysCalendar && !_vm.editing) ? _c('div', {
    staticClass: "itemsline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newHolidayName),
      expression: "newHolidayName"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": "Enter name",
      "name": "newHolidayName"
    },
    domProps: {
      "value": (_vm.newHolidayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newHolidayName = $event.target.value
      }
    }
  })]) : _vm._e(), (_vm.editing && !_vm.holidayName || _vm.editing && !_vm.isHolidaysCalendar) ? _c('div', {
    staticClass: "itemsline"
  }, [_c('button', {
    staticClass: "remove",
    class: {
      disabled: !_vm.canBeDeleted()
    },
    attrs: {
      "disabled": !_vm.canBeDeleted()
    },
    on: {
      "click": function($event) {
        return _vm.removeBooked()
      }
    }
  }, [_vm._v("Remove")]), _c('button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancelRemoveHolidays()
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "itemsline"
  }, [(!_vm.showOnly && !_vm.holidayName) ? _c('button', {
    staticClass: "save",
    class: {
      disabled: _vm.getMe.remainingDays < 1 && _vm.isHolidaysCalendar
    },
    attrs: {
      "disabled": _vm.isDisabled()
    },
    on: {
      "click": function($event) {
        return _vm.saveBooked()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _c('button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancelBooked()
      }
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-698891db"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./src/components/BookHolidayPopup/BookHolidayPopup.pug
// module id = 185
// module chunks = 1